




import Vue, { PropType } from 'vue';
import { ValidationData } from '@/stores/validation';

export default Vue.extend({
  name: 'GValidationMediator',
  props: {
    id: {
      type: String as PropType<string>,
      required: true,
    },
    validationData: {
      type: Object as PropType<ValidationData>,
      required: true,
    },
  },
  watch: {
    validationData(val) {
      this.$stores.validation.set(this.id, val);
    },
  },
  mounted() {
    this.$stores.validation.set(this.id, {
      untouched: true,
      touched: false,
      dirty: false,
      pristine: true,
      valid: true,
      invalid: false,
      validated: false,
      pending: false,
      required: false,
      changed: false,
      passed: false,
      failed: false,
      errors: {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      validate: async () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      reset: () => {},
    });
  },
  destroyed() {
    this.$stores.validation.delete(this.id);
  },
});
